export default function description() {
    return (
        <div className="card__description-basic">
            <div className="card__description">
                <div className="card__description-title">Загальна характеристика</div>
                <p className="card__description-text">
                    НС-X-6045 — це класичний представник екстенсивних гібридів, створений для роботи в умовах обмежених ресурсів. Його основна ідея — стабільність при мінімальному агрофоні, що робить його надійним вибором для складних полів.
                </p>
                <p className="card__description-text">
                    Гібрид демонструє хорошу витривалість та здатність формувати урожай навіть за несприятливих умов.
                </p>
                <ol className="card__description-list">
                    <p className="card__description-title">
                        Продуктивність і якість
                    </p>
                    <li className="card__description-numbering">Потенціал урожайності: до 5,0 т/га</li>
                    <li className="card__description-numbering">Олійність: до 50–52%</li>
                    <li className="card__description-numbering">Стійкість до вовчка: A–F</li>
                    <p className="card__description-text">
                        Стабільно формує врожай із високим вмістом олії, навіть у посушливих умовах.
                    </p>
                </ol>
                <div className="card__description-title">Морфологія та розвиток</div>
                <ol className="card__description-list">
                    <li className="card__description-numbering">Вегетаційний період: 111–114 днів</li>
                    <li className="card__description-numbering">Висота рослин: 170–190 см</li>
                    <p className="card__description-text">
                        Гібрид формує рівномірні, добре розвинені рослини з високою адаптивністю.
                    </p>
                </ol>
                <div className="card__description-title">Адаптивність</div>
                <ol className="card__description-list">
                    <p className="card__description-text">
                        Рекомендований для вирощування у:
                    </p>
                    <li className="card__description-numbering">Степу</li>
                    <li className="card__description-numbering">Лісостепу</li>
                    <p className="card__description-text">
                        Показує стабільні результати навіть у зонах із низьким рівнем вологозабезпечення.
                    </p>
                </ol>
                <div className="card__description-title">Ключові переваги</div>
                <ol className="card__description-list">
                    <li className="card__description-numbering">Працює при низькому агрофоні</li>
                    <li className="card__description-numbering">Стабільний урожай у посушливих умовах</li>
                    <li className="card__description-numbering">Придатний для засмічених полів (Clearfield®)</li>
                    <li className="card__description-numbering">Високий вміст олії</li>
                </ol>
                <div className="card__description-title">Практичне застосування</div>
                <ol className="card__description-list">
                    <p className="card__description-title">
                        НС-X-6045 — ідеальний вибір для:
                    </p>
                    <li className="card__description-numbering">екстенсивного землеробства</li>
                    <li className="card__description-numbering">полів із низькою родючістю</li>
                    <li className="card__description-numbering">господарств із обмеженими ресурсами</li>
                    <p className="card__description-text">
                        Рекомендується застосування гербіцидів системи Clearfield®.
                    </p>
                </ol>
                <div className="aside__title">Агрохімічні характеристики</div>
                <div className="aside__content">
                    <div className="aside-char--basic">
                        <div className="aside-char__head">Енергiя початкового росту</div>
                        <div className="aside-char__char">
                            <div className="aside-char__items aside-char__items--8">
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                            <div className="aside-char__count">8</div>
                        </div>
                    </div>
                    <div className="aside-char--basic">
                        <div className="aside-char__head">Посухостiйкiсть</div>
                        <div className="aside-char__char">
                            <div className="aside-char__items aside-char__items--9">
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                            <div className="aside-char__count">9</div>
                        </div>
                    </div>
                    <div className="aside-char--basic">
                        <div className="aside-char__head">Стiйкiсть до вилягання</div>
                        <div className="aside-char__char">
                            <div className="aside-char__items aside-char__items--8">
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                            <div className="aside-char__count">8</div>
                        </div>
                    </div>
                </div>
                <p className="card__description-text">
                    НС-X-6045 — це гібрид для тих, хто хоче стабільний результат навіть у складних умовах і без великих затрат.
                </p>
            </div>
            <div className="card__description-preference">
                <div className="aside__title--new">Головні переваги</div>
                <div className="asede__head">
                    <div className="aside__block">Екстенсивний гібрид, що витримує низький агрофон</div>
                    <div className="aside__block">Стабільні врожаї та високий вміст олії в посушливих умовах</div>
                    <div className="aside__block">Придатний для сівби на засмічених ділянках</div>
                </div>
            </div>
        </div>
    );
}
